import { render, staticRenderFns } from "./FavorecidosEdit.vue?vue&type=template&id=07a06c98&scoped=true&"
import script from "./FavorecidosEdit.vue?vue&type=script&lang=js&"
export * from "./FavorecidosEdit.vue?vue&type=script&lang=js&"
import style0 from "./FavorecidosEdit.vue?vue&type=style&index=0&id=07a06c98&prod&scoped=true&lang=css&"
import style1 from "./FavorecidosEdit.vue?vue&type=style&index=1&id=07a06c98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a06c98",
  null
  
)

export default component.exports